/**
 * Validates cart contents to prevent mixing subscription and non-subscription items
 * Only applies to the main cart page (not cart drawer)
 */
class SubscriptionCartValidator {
  constructor() {
    this.subscriptionTag = 'marca_sub';
    this.warningMessage = 'Subscription plans cannot be purchased alongside other items. Please remove other items before checking out with a subscription plan.';
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    console.log('[Subscription Validator] Setting up...');
    
    // Only run on cart page
    if (!document.querySelector('#cartform')) {
      console.log('[Subscription Validator] Not on cart page, exiting setup');
      return;
    }

    console.log('[Subscription Validator] Cart page detected, adding event listeners');

    // Listen for cart-form events - this is the key one that fires after DOM updates
    const cartForm = document.querySelector('cart-form');
    if (cartForm) {
      console.log('[Subscription Validator] Cart form found, adding listener');
      cartForm.addEventListener('on:cart:after-merge', () => {
        console.log('[Subscription Validator] on:cart:after-merge event received');
        // Small delay to ensure animation classes are applied
        setTimeout(() => {
          console.log('[Subscription Validator] Running validation after merge (with delay)');
          this.validateCart();
        }, 50);
      });
    } else {
      console.warn('[Subscription Validator] Cart form not found!');
    }

    // Also listen to document-level cart change as backup
    document.addEventListener('on:cart:change', () => {
      console.log('[Subscription Validator] on:cart:change event received (ignoring - waiting for merge event)');
      // We'll rely on on:cart:after-merge instead, which fires after DOM is updated
    });
    
    // Initial validation
    console.log('[Subscription Validator] Running initial validation');
    this.validateCart();
  }

  /**
   * Checks if cart has both subscription and non-subscription items
   * @returns {boolean}
   */
  hasConflict() {
    // Get all cart items, but exclude items that are being removed
    const allCartItems = document.querySelectorAll('.cart-item[data-product-tags]');
    
    console.log('[Subscription Validator] Total cart items in DOM:', allCartItems.length);
    
    // Log each item's classes to debug
    allCartItems.forEach((item, index) => {
      console.log(`[Subscription Validator] Item ${index} classes:`, item.className);
      console.log(`[Subscription Validator] Item ${index} has merge-remove-item:`, item.classList.contains('merge-remove-item'));
    });
    
    // Filter out items being removed
    const cartItems = Array.from(allCartItems).filter(item => {
      const isBeingRemoved = item.classList.contains('merge-remove-item');
      const hasWrapper = item.closest('.merge-remove-wrapper');
      return !isBeingRemoved && !hasWrapper;
    });
    
    console.log('[Subscription Validator] Active cart items (after filtering):', cartItems.length);
    
    if (cartItems.length === 0) {
      console.log('[Subscription Validator] No active items found, no conflict');
      return false;
    }

    let hasSubscription = false;
    let hasNonSubscription = false;

    cartItems.forEach((item, index) => {
      // Check if item has subscription tag
      const tags = item.dataset.productTags || '';
      const tagArray = tags.split(',').map(t => t.trim());
      
      console.log(`[Subscription Validator] Active item ${index} tags:`, tagArray);
      
      if (tagArray.includes(this.subscriptionTag)) {
        hasSubscription = true;
        console.log('[Subscription Validator] Found subscription item');
      } else {
        hasNonSubscription = true;
        console.log('[Subscription Validator] Found non-subscription item');
      }
    });

    const conflict = hasSubscription && hasNonSubscription;
    console.log('[Subscription Validator] Has conflict:', conflict);
    
    return conflict;
  }

  /**
   * Validates cart and updates UI accordingly
   */
  validateCart() {
    console.log('[Subscription Validator] validateCart() called');
    
    // Only validate if we're on the cart page
    if (!document.querySelector('#cartform')) {
      console.log('[Subscription Validator] Not on cart page, skipping');
      return;
    }

    const hasConflict = this.hasConflict();
    this.updateMainCart(hasConflict);
  }

  /**
   * Updates main cart page UI
   * @param {boolean} hasConflict
   */
  updateMainCart(hasConflict) {
    const checkoutButton = document.querySelector('#cartform [name="checkout"]');
    const warningContainer = document.querySelector('.subscription-warning-main-cart');
    const additionalCheckoutButtons = document.querySelector('.additional-checkout-buttons');

    if (!checkoutButton) return;

    if (hasConflict) {
      checkoutButton.setAttribute('disabled', 'disabled');
      checkoutButton.classList.add('btn--disabled');
      checkoutButton.style.opacity = '0.5';
      checkoutButton.style.cursor = 'not-allowed';
      
      // Also disable additional checkout buttons (Apple Pay, etc.)
      if (additionalCheckoutButtons) {
        additionalCheckoutButtons.style.pointerEvents = 'none';
        additionalCheckoutButtons.style.opacity = '0.5';
      }
      
      if (warningContainer) {
        warningContainer.hidden = false;
      }
      
      // Add click handler to prevent form submission
      if (!this.mainCartClickHandler) {
        this.mainCartClickHandler = (e) => {
          if (this.hasConflict()) {
            e.preventDefault();
            e.stopPropagation();
            alert(this.warningMessage);
          }
        };
        checkoutButton.addEventListener('click', this.mainCartClickHandler);
      }
    } else {
      checkoutButton.removeAttribute('disabled');
      checkoutButton.classList.remove('btn--disabled');
      checkoutButton.style.opacity = '';
      checkoutButton.style.cursor = '';
      
      // Re-enable additional checkout buttons
      if (additionalCheckoutButtons) {
        additionalCheckoutButtons.style.pointerEvents = '';
        additionalCheckoutButtons.style.opacity = '';
      }
      
      if (warningContainer) {
        warningContainer.hidden = true;
      }
    }
  }

}

// Initialize validator
new SubscriptionCartValidator();

